
        import * as module0 from './config/bifrost.js';import * as module1 from './config/page.js'

        const modules = [module0,module1];

        export default modules;
        export const filenames = ['./config/bifrost.js','./config/page.js']
      